// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__txpmD","wrapper":"PriceList_wrapper__LENPd","footerStyle":"PriceList_footerStyle__J52FB"};